var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceContractingcomponent = function SvgWorkspaceContractingcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7 10.5h12c3.315 0 6 2.685 6 6V30h-3v-4.5h-27V30h-3V7.5h3V21h12V10.5ZM15.2 15c0 2.49-2.01 4.5-4.5 4.5S6.2 17.49 6.2 15s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5Z",
    fill: "current"
  })));
};
export default SvgWorkspaceContractingcomponent;